
export const hasUserConsented = () => {
    return document.cookie.includes("user_consent=true") || document.cookie.includes("user_consent_beta=true");
  };
  
  export const trackPageView = (pagePath) => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
      return;
    }

    const normalizedPath = pagePath || window.location.pathname;

    window.gtag('event', 'page_view', {
      page_path: normalizedPath,
      page_location: window.location.href,
      page_title: document.title,
    });
  };

  export const handleAnalyticsEvent = (eventType, eventCategory, eventLabel) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function' && hasUserConsented()) {
        // console.log(hasUserConsented())
      window.gtag('event', eventType, {
        'event_category': eventCategory,
        'event_label': eventLabel,
      });
    }
  };

  
  
